// src/components/EditUserModal.jsx

import React, { useState, useContext } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { AuthContext } from '../../context/AuthContext';

export default function EditUserModal({ user, onClose, onUserUpdated }) {
  const intl = useIntl();
  const { user: currentUser } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    name: user.name || '',
    email: user.email || '',
    cpf: user.cpf || '',
    creci: user.creci || '',
    whatsapp: user.whatsapp || ''
  });

  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const userRef = doc(db, 'users', user.id || currentUser?.uid);
      await updateDoc(userRef, {
        name: formData.name,
        email: formData.email,
        cpf: formData.cpf,
        creci: formData.creci,
        whatsapp: formData.whatsapp
      });
      
      toast.success(intl.formatMessage({ id: 'saveSuccess', defaultMessage: 'Dados salvos com sucesso!' }));
      if (onUserUpdated) {
        onUserUpdated({ ...user, ...formData });
      }
      onClose();
      
    } catch (error) {
      console.error('Erro ao atualizar usuário:', error);
      toast.error(intl.formatMessage({ id: 'saveError', defaultMessage: 'Erro ao salvar.' }));
    }

    setSaving(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{intl.formatMessage({ id: 'user.editTitle', defaultMessage: 'Editar Cadastro' })}</h2>

        <form className="modal-form" onSubmit={handleSubmit}>
          <label>{intl.formatMessage({ id: 'form.name', defaultMessage: 'Nome' })}</label>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label>{intl.formatMessage({ id: 'user.email', defaultMessage: 'Email' })}</label>
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label>CPF</label>
          <input
            name="cpf"
            value={formData.cpf}
            onChange={handleChange}
          />

          <label>CRECI</label>
          <input
            name="creci"
            value={formData.creci}
            onChange={handleChange}
          />

          <label>WhatsApp (opcional)</label>
          <input
            name="whatsapp"
            value={formData.whatsapp}
            onChange={handleChange}
            placeholder="+55 11 91234-5678"
          />

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="cancel-btn">
              {intl.formatMessage({ id: 'general.cancel', defaultMessage: 'Cancelar' })}
            </button>
            <button type="submit" className="save-btn" disabled={saving}>
              {saving
                ? intl.formatMessage({ id: 'general.saving', defaultMessage: 'Salvando...' })
                : intl.formatMessage({ id: 'general.save', defaultMessage: 'Salvar' })}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
